/**
 * Query param the public `/templates/details/:slug` page expects for
 * `url_secret` / `guest_viewer` access (subject id from the share API).
 */
export const TEMPLATE_DETAILS_URL_SECRET_QUERY_PARAM = "secret";

/**
 * Absolute URL for the template details page on the current web origin.
 * When `urlSecretId` is set (general access enabled), appends the secret so
 * the link works for users without a direct permission grant.
 *
 * Returns undefined when `slug` is missing or blank (after trim).
 */
export function buildTemplateDetailsPublicUrl(
  origin: string,
  slug: string | null | undefined,
  urlSecretId?: string | null,
): string | undefined {
  const trimmedSlug = slug?.trim();
  if (!trimmedSlug) {
    return undefined;
  }

  const base = `${origin.replace(/\/$/, "")}/templates/details/${trimmedSlug}`;
  const secret = urlSecretId?.trim();
  if (!secret) {
    return base;
  }

  const query = new URLSearchParams({
    [TEMPLATE_DETAILS_URL_SECRET_QUERY_PARAM]: secret,
  }).toString();

  return `${base}?${query}`;
}
